import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import BlockUi from 'react-block-ui';
import Api from '../../api/global.service';
import {
  INFO_GENERAL,
  INFO_EDADES_VARIEDADES,
  INFO_INSPECCION_PARCELA,
  INFO_BOSQUES_ANP,
  INFO_USO_SUELO_TENENCIA,
  INFO_COLINDANTES_Y_RIESGOS,
} from '../../constants/EudrSicLabels';
import { useCoopConfig } from '../content/coop-config';
import transformWord from '../../utils/transformWord';
import env from '../../environment';

const ACC_STYLE = {
  bgcolor: 'transparent',
  '&:before': { display: 'none' },
  '& .MuiAccordionSummary-root': {
    minHeight: 'auto',
    padding: 0,
  },
  '& .MuiAccordionDetails-root': {
    padding: '8px 16px',
  },
  borderBottom: '1px solid #e0e0e0',
};

const EudrSicAccordion = ({ uuid, isPrinting }) => {
  const coopConfig = useCoopConfig();
  const producto = transformWord(coopConfig.config?.cooperativa?.producto?.nombre || 'café', ['singular', 'lowercase']);
  const [blocking, setBlocking] = useState(true);
  const [sicData, setSicData] = useState({});
  const [acc1, setAcc1] = useState(false);
  const [acc2, setAcc2] = useState(false);
  const [acc3, setAcc3] = useState(false);
  const [acc4, setAcc4] = useState(false);
  const [acc5, setAcc5] = useState(false);
  const [acc6, setAcc6] = useState(false);

  useEffect(() => {
    if (uuid != null) {
      Api.get('parcela_eudr_sic_info', uuid)
        .then(response => {
          setSicData(response.data);
          setBlocking(false);
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.log('error:', e);
          setBlocking(false);
        });
    }
  }, []);

  useEffect(() => {
    if (isPrinting) {
      setAcc1(true);
      setAcc2(true);
      setAcc3(true);
      setAcc4(true);
      setAcc5(true);
      setAcc6(true);
    }
  }, [isPrinting]);

  const getRow = (item, data) => {
    if (item.var in sicData && data[item.var]) {
      let content = <span style={{ minWidth: '25%', fontWeight: 'bold', textAlign: 'right' }}>{data[item.var]}</span>;
      if (item.isImage) {
        content = <img src={`${env.apiURL}/${data[item.var]}`} style={{ width: '45%', marginLeft: '8px' }}></img>;
      }
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            fontSize: '12px',
            marginBottom: '5px',
            borderTop: '1px ridge',
            paddingTop: '4px',
          }}
          key={item.var}>
          {item.label}
          {content}
        </div>
      );
    }
  };

  return (
    <>
      <h4>Información adicional:</h4>
      <p>Ésta información es la capturada en la ficha acerca de las prácticas en parcela en relación a deforestación y colindantes:</p>
      <BlockUi tag="div" message="" blocking={blocking} renderChildren={true} style={{ marginTop: '20px' }}>
        <Accordion expanded={acc1} onChange={() => setAcc1(!acc1)} elevation={0} sx={ACC_STYLE}>
          <AccordionSummary expandIcon={<i className="fa fa-plus" aria-hidden="true"></i>}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Información general</Typography>
          </AccordionSummary>
          <AccordionDetails>{INFO_GENERAL.map(item => getRow(item, sicData))}</AccordionDetails>
        </Accordion>

        <Accordion expanded={acc2} onChange={() => setAcc2(!acc2)} elevation={0} disableGutters sx={ACC_STYLE}>
          <AccordionSummary expandIcon={<i className="fa fa-plus" aria-hidden="true"></i>}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Edades y variedades de {producto}</Typography>
          </AccordionSummary>
          <AccordionDetails>{INFO_EDADES_VARIEDADES.map(item => getRow(item, sicData))}</AccordionDetails>
        </Accordion>

        <Accordion expanded={acc3} onChange={() => setAcc3(!acc3)} elevation={0} disableGutters sx={ACC_STYLE}>
          <AccordionSummary expandIcon={<i className="fa fa-plus" aria-hidden="true"></i>}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Inspección de la parcela</Typography>
          </AccordionSummary>
          <AccordionDetails>{INFO_INSPECCION_PARCELA.map(item => getRow(item, sicData))}</AccordionDetails>
        </Accordion>

        <Accordion expanded={acc4} onChange={() => setAcc4(!acc4)} elevation={0} disableGutters sx={ACC_STYLE}>
          <AccordionSummary expandIcon={<i className="fa fa-plus" aria-hidden="true"></i>}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Bosques y Áreas Naturales Protegidas</Typography>
          </AccordionSummary>
          <AccordionDetails>{INFO_BOSQUES_ANP.map(item => getRow(item, sicData))}</AccordionDetails>
        </Accordion>

        <Accordion expanded={acc5} onChange={() => setAcc5(!acc5)} elevation={0} disableGutters sx={ACC_STYLE}>
          <AccordionSummary expandIcon={<i className="fa fa-plus" aria-hidden="true"></i>}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Uso de suelo / Tenencia de la tierra</Typography>
          </AccordionSummary>
          <AccordionDetails>{INFO_USO_SUELO_TENENCIA.map(item => getRow(item, sicData))}</AccordionDetails>
        </Accordion>

        <Accordion expanded={acc6} onChange={() => setAcc6(!acc6)} elevation={0} disableGutters sx={ACC_STYLE}>
          <AccordionSummary expandIcon={<i className="fa fa-plus" aria-hidden="true"></i>}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Colindantes y riesgos</Typography>
          </AccordionSummary>
          <AccordionDetails>{INFO_COLINDANTES_Y_RIESGOS.map(item => getRow(item, sicData))}</AccordionDetails>
        </Accordion>
      </BlockUi>
    </>
  );
};

export default EudrSicAccordion;
